import React, {
  useEffect,
  useState,
  useContext,
  useRef,
} from 'react';
import CustomSelect from 'react-select';

//styles
import styles from './InstallLanding.module.scss';
import copyOFNewUserModal from '../../../shared/NewUserModal.module.scss';

//functions
import { changeFaToEn } from '../../../functions/changeFaToEn';
import { notify } from '../../../functions/toasts';
import { responseHandler } from '../../../functions/responseHandler';
import { debounce } from 'lodash';

//dependencys
import { useParams, useNavigate } from 'react-router-dom';
import { HexColorPicker } from 'react-colorful';
import axios from 'axios';
//contexts
import { myUserDataContext } from '../../../App';

//components
import Loading from '../../../shared/Loading';

//shared
import ModalYesorNo from '../../../shared/ModalYesorNo';
import { Flex, Select, Spin } from 'antd';

const InstallLanding = () => {
  const params = useParams();
  const navigate = useNavigate();

  const [checkBtnErsal, setCheckBtnErsal] = useState(false);

  const data = useContext(myUserDataContext);
  const { userData, isLogin } = data;
  const { token } = userData;

  const [dataOfTemplate, setDataOfTemplate] = useState({});
  const [isLoad, setIsLoad] = useState(true);
  const [loadingType, setLoadingType] = useState();
  const [groups, setGroups] = useState([]);

  const [selectOptions, setSelectOptions] = useState({
    subject: [],
    label: [],
    type: [],
  });
  const [totalSelect, setTotalSelect] = useState({
    subject: '',
    label: '',
    type: '',
  });

  const [advance, setAdvance] = useState(false);

  const [disableSubjectAndLabel, setDisableSubjectAndLabel] =
    useState(false);

  const [dataForSend, setDataForSend] = useState({
    title: '',
    slug: '',
    description: '',
    is_child: '0',
    access_group_id: '',
    parameters: {},
    template_id: params.id,
    time_change: '',
    view_change: '',
    parameter_change: '',
    parameter_group: {
      CTR_target: '',
      change_type: 'view_change',
    },
    landing_group: {
      CTR_target: '',
      change_type: '',
      landings: [
        { id: '', priority: '', time_change: '', view_change: '' },
      ],
    },
  });

  const fetchGroups = async (title = '') => {
    try {
      const url = `/access-group/get-user-list?name=${encodeURIComponent(
        title
      )}`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setGroups(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const debouncedFetchGroups = debounce((value) => {
    if (value.length >= 2) {
      fetchGroups(value);
    }
  }, 500);

  const handleInputChangeGroups = (value) => {
    debouncedFetchGroups(value);
  };

  const handleChangeGroups = (selectedOption) => {
    setDataForSend((prev) => ({
      ...prev,
      access_group_id: selectedOption?.value || '',
    }));
  };

  const handleAddGroup = () => {
    setDataForSend((prev) => {
      return {
        ...prev,
        landing_group: {
          ...prev.landing_group,
          landings: [
            ...prev.landing_group.landings,
            { id: '', priority: '', time_change: '' },
          ],
        },
      };
    });
  };

  const handleChange = (index, field, value) => {
    const updated = [...dataForSend.landing_group.landings];
    updated[index][field] = value;
    setDataForSend((prev) => ({
      ...prev,
      landing_group: {
        ...prev.landing_group,
        landings: updated,
      },
    }));
  };

  const handleCtrTarget = (e) => {
    setDataForSend((prev) => ({
      ...prev,
      landing_group: {
        ...prev.landing_group,
        CTR_target: e.target.value,
      },
    }));
  };

  const handleCtrTargetParameters = (e) => {
    setDataForSend((prev) => ({
      ...prev,
      parameter_group: {
        ...prev.parameter_group,
        CTR_target: e.target.value,
      },
    }));
  };

  // const getSelectOptions = () => {
  //   setIsLoad(true);
  //   axios
  //     .get('/landing/get-landing-subjects', {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .then((res) => {
  //       if (res.data.status) {
  //         setSelectOptions({
  //           subject: res.data.subjects,
  //           label: res.data.labels,
  //         });
  //         setIsLoad(false);
  //       } else {
  //         responseHandler(res, 'error');
  //       }
  //     })
  //     .catch((error) => {
  //       responseHandler(error, 'error');
  //     });
  // };

  /////////////
  const getTypeOptions = (first) => {
    setLoadingType(true);
    axios
      .get(`/landing/get-landing-types?token=${first}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status) {
          setSelectOptions((prev) => ({
            ...prev,
            type: res.data?.data?.types,
          }));

          setLoadingType(false);
        } else {
          //    responseHandler(res, "error");
        }
      })
      .catch((error) => {
        //    responseHandler(error, "error");
      });
  };

  useEffect(() => {
    const getRun = () => {
      axios
        .get(`/template/show/${params.id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data.status) {
            setDataOfTemplate(res.data.data);
            setIsLoad(false);

            // getSelectOptions();
          }
        })
        .catch((error) => {
          responseHandler(error, 'error');
          if (error.response?.status === 404)
            navigate('/notfound', { replace: true });
        });
    };

    getRun();
  }, []);

  const [allLandings, setAllLandings] = useState([]);

  const fetchLandings = async (title = '') => {
    try {
      const url = title
        ? `/landing/search-landing?title=${encodeURIComponent(title)}`
        : `/landing/search-landing`;

      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.status) {
        const options = res.data.data.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        setAllLandings(options);
      }
    } catch (err) {
      responseHandler(err, 'error');
    }
  };

  useEffect(() => {
    fetchLandings();
  }, []);

  const debouncedFetch = debounce((value) => {
    if (value.length >= 2) {
      fetchLandings(value);
    }
  }, 500);

  const handleInputChange = (value) => {
    debouncedFetch(value);
  };

  const inputHandler = (e) => {
    const first = changeFaToEn(e.target.value);
    setDataForSend({ ...dataForSend, [e.target.name]: first });
  };

  const inputParaHandler = (e) => {
    let first = changeFaToEn(e.target.value);
    const name = e.target.name;

    setDataForSend({
      ...dataForSend,
      parameters: {
        ...dataForSend.parameters,
        [name === 'typeSelect' ? 'type' : name]: first,
      },
    });
  };

  const inputParaHandler2 = (e, key) => {
    const first = changeFaToEn(e.target.value);
    getTypeOptions(first);
    setDataForSend({
      ...dataForSend,
      parameters: {
        ...dataForSend.parameters,
        [e.target.name]: first,
      },
    });

    setDataForSend((prev) => {
      const updatedParameters = {
        ...prev?.[key],
        [e.target.name]: first,
      };

      const variantIndex = Object.keys(prev)
        .filter(
          (k) => k.startsWith('parameters') && k !== 'parameters'
        )
        .findIndex((k) => k === key);

      const updatedVariants = [
        ...(prev?.parameter_group?.variants || []),
      ];
      if (variantIndex >= 0) {
        updatedVariants[variantIndex] = {
          ...updatedVariants[variantIndex],
          parameters: updatedParameters,
        };
      }

      return {
        ...prev,
        [key]: updatedParameters,
        parameter_group: {
          ...prev.parameter_group,
          variants: updatedVariants,
        },
      };
    });
  };

  const inputParaHandler3 = (e, key) => {
    const first = changeFaToEn(e.target.value);
    getTypeOptions(first);
    setDataForSend({
      ...dataForSend,
      parameters: {
        ...dataForSend.parameters,
        [e.target.name]: first,
      },
    });

    setDataForSend((prev) => {
      const updatedParameters = {
        ...prev?.[key],
        [e.target.name]: first,
      };

      const variantIndex = Object.keys(prev)
        .filter(
          (k) => k.startsWith('parameters') && k !== 'parameters'
        )
        .findIndex((k) => k === key);

      const updatedVariants = [
        ...(prev.parameter_group?.variants || []),
      ];
      if (variantIndex >= 0) {
        updatedVariants[variantIndex] = {
          ...updatedVariants[variantIndex],
          parameters: updatedParameters,
        };
      }

      return {
        ...prev,
        [key]: updatedParameters,
        parameter_group: {
          ...prev.parameter_group,
          variants: updatedVariants,
        },
      };
    });
  };

  const inputParaHandlerOthers = (e, key) => {
    const first = changeFaToEn(e.target.value);
    const name = e.target.name;
    const finalName = name === 'typeSelect' ? 'type' : name;

    setDataForSend((prev) => {
      const updatedParameters = {
        ...prev[key],
        [finalName]: first,
      };

      const variantIndex = Object.keys(prev)
        .filter(
          (k) => k.startsWith('parameters') && k !== 'parameters'
        )
        .findIndex((k) => k === key);

      const updatedVariants = [
        ...(prev.parameter_group?.variants || []),
      ];
      if (variantIndex >= 0) {
        updatedVariants[variantIndex] = {
          ...updatedVariants[variantIndex],
          parameters: updatedParameters,
        };
      }

      return {
        ...prev,
        [key]: updatedParameters,
        parameter_group: {
          ...prev.parameter_group,
          variants: updatedVariants,
        },
      };
    });
  };

  const inputParaHandlerOthers2 = (e, key) => {
    const first = changeFaToEn(e.target.value);
    getTypeOptions(first);

    setDataForSend((prev) => {
      const updatedParameters = {
        ...prev[key],
        [e.target.name]: first,
      };

      const variantIndex = Object.keys(prev)
        .filter(
          (k) => k.startsWith('parameters') && k !== 'parameters'
        )
        .findIndex((k) => k === key);

      const updatedVariants = [
        ...(prev.parameter_group?.variants || []),
      ];
      if (variantIndex >= 0) {
        updatedVariants[variantIndex] = {
          ...updatedVariants[variantIndex],
          parameters: updatedParameters,
        };
      }

      return {
        ...prev,
        [key]: updatedParameters,
        parameter_group: {
          ...prev.parameter_group,
          variants: updatedVariants,
        },
      };
    });
  };

  const colorHandler = (e, name, type) => {
    if (type === 'input') {
      setDataForSend({
        ...dataForSend,
        parameters: {
          ...dataForSend.parameters,
          [name]: e.target.value,
        },
      });
    } else if ('picker') {
      setDataForSend({
        ...dataForSend,
        parameters: { ...dataForSend.parameters, [name]: e },
      });
    }
  };
  const colorHandler2 = (e, name, type, key) => {
    const value = type === 'input' ? e.target.value : e;

    setDataForSend((prev) => {
      const updatedParameters = {
        ...prev[key],
        [name]: value,
      };

      const variantIndex = Object.keys(prev)
        .filter(
          (k) => k.startsWith('parameters') && k !== 'parameters'
        )
        .findIndex((k) => k === key);

      const updatedVariants = [
        ...(prev.parameter_group?.variants || []),
      ];
      if (variantIndex >= 0) {
        updatedVariants[variantIndex] = {
          ...updatedVariants[variantIndex],
          parameters: updatedParameters,
        };
      }

      return {
        ...prev,
        [key]: updatedParameters,
        parameter_group: {
          ...prev.parameter_group,
          variants: updatedVariants,
        },
      };
    });
  };

  const selectParaHandler = (e) => {
    let first = changeFaToEn(e.target.value);

    setTotalSelect({ ...totalSelect, [e.target.name]: first });
  };

  const [othersParameters, setOthersParameters] = useState({
    variants: [],
  });

  const [paramIndex, setParamIndex] = useState(0);

  if (!isLoad) {
    var { parameters } = dataOfTemplate;
    var myParameters = JSON?.parse(parameters);
  }

  const addParameters = (sourceKey = null) => {
    setParamIndex((prev) => {
      const nextIndex = prev + 1;

      setOthersParameters((othersPrev) => {
        const source = sourceKey
          ? othersPrev.variants?.find((v) => v[sourceKey])?.[
              sourceKey
            ]
          : myParameters;

        return {
          ...othersPrev,
          variants: [
            ...(othersPrev.variants || []),
            {
              [`parameters${nextIndex}`]: source,
              priority: '',
              time_change: '',
              view_change: '',
            },
          ],
        };
      });

      setDataForSend((prevData) => ({
        ...prevData,
        [`parameters${nextIndex}`]: sourceKey
          ? prevData[sourceKey] ?? {}
          : prevData.parameters,
      }));

      return nextIndex;
    });
  };

  const removeParameter = (paramKey) => {
    setOthersParameters((prev) => {
      const updatedVariants = (prev.variants || []).filter(
        (variant) => !variant.hasOwnProperty(paramKey)
      );
      return {
        ...prev,
        variants: updatedVariants,
      };
    });

    setDataForSend((prev) => {
      const newData = { ...prev };
      delete newData[paramKey];
      return newData;
    });
  };

  const isUpdatingVariants = useRef(false);

  useEffect(() => {
    if (isUpdatingVariants.current) return;

    isUpdatingVariants.current = true;

    setDataForSend((prevData) => {
      const newVariants = Object.entries(prevData)
        .filter(
          ([key]) =>
            key.startsWith('parameters') && key !== 'parameters'
        )
        .map(([key, value]) => {
          const prevMeta =
            othersParameters.variants?.find((v) => v[key]) || {};

          return {
            parameters: value,
            priority: prevMeta.priority || '',
            time_change: prevMeta.time_change || '',
            view_change: prevMeta.view_change || '',
          };
        });

      return {
        ...prevData,
        parameter_group: {
          ...prevData.parameter_group,
          ...othersParameters,
          variants: newVariants,
        },
      };
    });

    setTimeout(() => {
      isUpdatingVariants.current = false;
    }, 0);
  }, [othersParameters]);

  const onlyParameters = othersParameters?.variants?.reduce(
    (acc, item) => {
      const key = Object.keys(item).find((k) =>
        k.startsWith('parameters')
      );
      if (key) {
        acc[key] = item[key];
      }
      return acc;
    },
    {}
  );

  useEffect(() => {
    if (!isLoad) {
      let tempKeys = {};

      for (let item of myParameters) {
        for (let paraItem of item.parameters) {
          tempKeys[paraItem.paraName] = '';
        }
      }

      setDataForSend({ ...dataForSend, parameters: tempKeys });
    }
  }, [isLoad]);

  const ColorPickerShowHandler = (e, type) => {
    if (type === 'enter') {
      e.target.previousElementSibling.style.display = 'initial';
    } else if (type === 'leave') {
      let currentElement = e.target;

      while (currentElement.parentElement) {
        currentElement = currentElement.parentElement;

        if (currentElement.id.includes('test')) {
          currentElement.style.display = 'none';
          break;
        }
      }
    }
  };

  const SendHandler = () => {
    setCheckBtnErsal(true);

    const filteredLandings = dataForSend.landing_group.landings || [];
    const filteredvariants =
      dataForSend.parameter_group.variants || [];

    const formData = new FormData();

    if (dataForSend.title)
      formData.append('title', dataForSend.title);
    if (dataForSend.slug) formData.append('slug', dataForSend.slug);
    if (dataForSend.access_group_id)
      formData.append('access_group_id', dataForSend.access_group_id);
    if (dataForSend.description)
      formData.append('description', dataForSend.description);

    formData.append(
      'parameters',
      JSON.stringify({
        ...dataForSend.parameters,
        baseAndMainTitle: dataForSend.title,
        subject: totalSelect.subject,
        label: totalSelect.label,
      })
    );

    if (filteredLandings.length > 0 && dataForSend?.is_child != 1) {
      if (dataForSend.landing_group.CTR_target)
        formData.append(
          'landing_group[CTR_target]',
          dataForSend.landing_group.CTR_target
        );

      if (dataForSend.landing_group.change_type)
        formData.append(
          'landing_group[change_type]',
          dataForSend.landing_group.change_type
        );

      filteredLandings.forEach((landing, index) => {
        if (landing.id)
          formData.append(
            `landing_group[landings][${index}][id]`,
            landing.id
          );
        if (landing.priority)
          formData.append(
            `landing_group[landings][${index}][priority]`,
            landing.priority
          );
        if (landing.time_change)
          formData.append(
            `landing_group[landings][${index}][time_change]`,
            landing.time_change
          );
        if (landing.view_change)
          formData.append(
            `landing_group[landings][${index}][view_change]`,
            landing.view_change
          );
      });
    }

    if (dataForSend.parameter_group.CTR_target !== '')
      formData.append(
        'parameter_group[CTR_target]',
        dataForSend.parameter_group.CTR_target
      );

    if (dataForSend.parameter_group?.change_type && advance == 1)
      formData.append(
        'parameter_group[change_type]',
        dataForSend.parameter_group.change_type
      );

    if (advance == 1) {
      filteredvariants.forEach((item, index) => {
        formData.append(
          `parameter_group[variants][${index}][parameters]`,
          JSON.stringify(item.parameters)
        );

        if (item.priority)
          formData.append(
            `parameter_group[variants][${index}][priority]`,
            item.priority
          );
        if (item.time_change)
          formData.append(
            `parameter_group[variants][${index}][time_change]`,
            item.time_change
          );
        if (item.view_change)
          formData.append(
            `parameter_group[variants][${index}][view_change]`,
            item.view_change
          );
      });
    }

    if (dataForSend.template_id)
      formData.append('template_id', dataForSend.template_id);

    formData.append('is_child', dataForSend.is_child);

    if (dataForSend.time_change !== '')
      formData.append('time_change', dataForSend.time_change);

    if (dataForSend.parameter_change !== '' && advance == 1)
      formData.append(
        'parameter_change',
        dataForSend.parameter_change
      );

    if (dataForSend.view_change !== '')
      formData.append('view_change', dataForSend.view_change);

    if (userData.user.id)
      formData.append('user_id', userData.user.id);

    const sendMainRequest = () => {
      axios
        .post('/landing/create', formData, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          responseHandler(res, 'succ');
          if (res.data.status) navigate('/dashboard/showLandings');
          setCheckBtnErsal(false);
        })
        .catch((error) => {
          responseHandler(error, 'error');
          setCheckBtnErsal(false);
        });
    };

    sendMainRequest();
  };

  const cheakeAll = () => {
    setCheckBtnErsal(true);

    if (
      dataForSend.parameters.type === '' ||
      dataForSend.parameters.token === ''
    ) {
      notify('تایپ و توکن الزامی است', 'error', 2000);
      setCheckBtnErsal(false);
      return;
    }

    if (dataForSend.title === '') {
      notify('عنوان لندینگ نمی‌تواند خالی باشد', 'error');
      setCheckBtnErsal(false);
      return;
    }

    const totalHamkadehOrNot =
      dataForSend.parameters.hamkadehOrNot !== undefined
        ? dataForSend.parameters.hamkadehOrNot
        : dataForSend.parameters.HamkadehOrNot;
    if (totalHamkadehOrNot === '' && totalSelect.label === '') {
      notify(
        'در صورتی که لندینگ برای همکده است باید برچسب و تمامی موارد در بخش ملزومات لندینگ را وارد کنید',
        'error',
        4500
      );
      setCheckBtnErsal(false);
      return;
    }

    // if (totalSelect.label !== '' && totalSelect.subject === '') {
    //   notify(
    //     'در صورت انتخاب برچسب باید موضوع را هم انتخاب کرده باشید',
    //     'error',
    //     2000
    //   );
    //   setCheckBtnErsal(false);
    //   return;
    // }

    // if (
    //   totalSelect.subject !== '' &&
    //   dataForSend.parameters.type === ''
    // ) {
    //   notify(
    //     'اگر موضوع انتخاب کرده باشید باید تایپ هم داشته باشید',
    //     'error',
    //     2000
    //   );
    //   setCheckBtnErsal(false);
    //   return;
    // }

    // if (
    //   totalSelect.subject !== '' &&
    //   dataForSend.parameters.token === ''
    // ) {
    //   notify(
    //     'اگر موضوع انتخاب کرده باشید باید توکن هم داشته باشید',
    //     'error',
    //     2000
    //   );
    //   setCheckBtnErsal(false);
    //   return;
    // }

    document.getElementById('btnModalAnswer').click();
  };

  const [isLoadForModalCheck, setIsLoadForModalCheck] =
    useState(true);
  const [dataForModalCheck, setDataForModalCheck] = useState(null);

  const showAwnserForLanding = () => {
    setIsLoadForModalCheck(true);

    if (
      !dataForSend.parameters.type &&
      !dataForSend.parameters.token
    ) {
      setDataForModalCheck({ count: 0 });
      setIsLoadForModalCheck(false);
      setCheckBtnErsal(false);
    } else {
      const body = {
        type: dataForSend.parameters.type,
        token: dataForSend.parameters.token,
      };

      axios
        .post(`/landing/get-token-type-count`, body, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res.data.status) {
            setDataForModalCheck(res.data.data);
            setIsLoadForModalCheck(false);
            setCheckBtnErsal(false);
          } else {
            notify(res.data.message, 'error');
            setCheckBtnErsal(false);
          }
        })
        .catch((error) => {
          responseHandler(error, 'error');
          setCheckBtnErsal(false);
        });
    }
  };

  const handlePriority = (e, index) => {
    setOthersParameters((prev) => {
      const updatedvariants = [...prev.variants];
      updatedvariants[index] = {
        ...updatedvariants[index],
        priority: e.target.value,
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const handleDurationChange = (e, index) => {
    setOthersParameters((prev) => {
      const updatedvariants = [...prev.variants];

      updatedvariants[index] = {
        ...updatedvariants[index],
        time_change: e.target.value,
        view_change: '',
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const handleViewChange = (e, index) => {
    setOthersParameters((prev) => {
      const updatedvariants = [...prev.variants];

      updatedvariants[index] = {
        ...updatedvariants[index],
        view_change: e.target.value,
        time_change: '',
      };

      return {
        ...prev,
        variants: updatedvariants,
      };
    });
  };

  const handleChangeViewLanding = (value, index) => {
    setDataForSend((prev) => {
      const updatedLandings = [
        ...(prev.landing_group?.landings || []),
      ];

      updatedLandings[index] = {
        ...updatedLandings[index],
        view_change: value,
        time_change: '',
      };

      return {
        ...prev,
        view_change: value,
        landing_group: {
          ...prev.landing_group,
          landings: updatedLandings,
        },
      };
    });
  };

  const handleChangeTimeLanding = (value, index) => {
    setDataForSend((prev) => {
      const updatedLandings = [
        ...(prev.landing_group?.landings || []),
      ];

      updatedLandings[index] = {
        ...updatedLandings[index],
        time_change: value,
        view_change: '',
      };

      return {
        ...prev,
        time_change: value,
        landing_group: {
          ...prev.landing_group,
          landings: updatedLandings,
        },
      };
    });
  };

  const handlePriorityLanding = (value, index) => {
    setDataForSend((prev) => {
      const updatedLandings = [
        ...(prev.landing_group?.landings || []),
      ];

      updatedLandings[index] = {
        ...updatedLandings[index],
        priority: value,
      };

      return {
        ...prev,
        landing_group: {
          ...prev.landing_group,
          landings: updatedLandings,
        },
      };
    });
  };

  return !isLoad && isLogin ? (
    <>
      <div className={styles.InstallLandingDiv}>
        <div className={styles.title}>
          <span>{`ایجاد لندینگ از  ${dataOfTemplate.title}`}</span>
          <i className="bi bi-front"></i>
        </div>

        <div className={styles.consts}>
          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="titleLanding">عنوان لندینگ:</label>
            <input
              type="text"
              id="titleLanding"
              name="title"
              value={dataForSend.title}
              onChange={inputHandler}
            />
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="slugLanding">آدرس لندینگ:</label>
            <input
              type="text"
              id="slugLanding"
              name="slug"
              value={dataForSend.slug}
              onChange={inputHandler}
            />
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="childLanding">
              آیا این لندینگ فرزند است؟
            </label>
            <select
              defaultValue={false}
              className={`${styles.SelectPanel} form-select`}
              onChange={(e) => {
                const value = e.target.value;
                setDataForSend((prev) => ({
                  ...prev,
                  is_child: value,
                }));
              }}
            >
              <option value={0}>خیر</option>
              <option value={1}>بله</option>
            </select>
          </div>

          <div className={copyOFNewUserModal.Inputs}>
            <label htmlFor="slugLanding">
              آیا نیاز به لندینگ پیشرفته دارید؟
            </label>
            <select
              defaultValue={false}
              className={`${styles.SelectPanel} form-select`}
              onChange={(e) => {
                const value = e.target.value;
                setAdvance(value);
              }}
            >
              <option value={0}>خیر</option>
              <option value={1}>بله</option>
            </select>
          </div>

          {groups?.length > 0 && (
            <div>
              <div
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                }}
              >
                <label htmlFor="slugLanding">انتخاب گروه :</label>
                <CustomSelect
                  options={groups}
                  placeholder="گروه را انتخاب کنید"
                  onInputChange={handleInputChangeGroups}
                  onChange={handleChangeGroups}
                  isClearable
                  isSearchable
                />
              </div>
            </div>
          )}
        </div>

        <div className={styles.titleTopAccordion}>
          <span>پارامتر ها</span>
        </div>

        {advance == 1 && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
            }}
          >
            <div
              style={{ minWidth: '30%' }}
              className={styles.ParaDiv}
            >
              <div className={styles.toptext}>
                <label className={styles.ParaName}>هدف CTR</label>
                <span className={styles.paraDec}>
                  درصد CTR مورد نظر را وارد کنید(فقط عدد)
                </span>
              </div>
              <input
                type="text"
                onChange={(e) => handleCtrTargetParameters(e)}
              />
            </div>
            <div
              style={{ minWidth: '30%' }}
              className={styles.ParaDiv}
            >
              <div className={styles.toptext}>
                <label className={styles.ParaName}>CTR براساس:</label>
                <span className={styles.paraDec}>
                  براساس تعداد بازدید یا مدت زمان
                </span>
              </div>
              <select
                className={`${styles.SelectPanel} form-select`}
                value={dataForSend?.parameter_group?.view_change}
                onChange={(e) => {
                  const value = e.target.value;
                  setDataForSend((prev) => ({
                    ...prev,
                    parameter_group: {
                      ...prev.parameter_group,
                      change_type: value,
                    },
                  }));
                }}
              >
                <option value="view_change">تعداد بازدید</option>
                <option value="time_change">مدت زمان</option>
              </select>
            </div>

            {dataForSend?.parameter_group?.change_type ===
            'time_change' ? (
              <div
                style={{ minWidth: '30%' }}
                className={styles.ParaDiv}
              >
                <div className={styles.toptext}>
                  <label className={styles.ParaName}>مدت زمان</label>
                  <span className={styles.paraDec}>
                    مدت زمان مورد نظر برای محاسبه CTR(دقیقه)
                  </span>
                </div>
                <input
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value;
                    setDataForSend((prev) => ({
                      ...prev,
                      parameter_change: value,
                    }));
                  }}
                />
              </div>
            ) : (
              <div
                style={{ minWidth: '30%' }}
                className={styles.ParaDiv}
              >
                <div className={styles.toptext}>
                  <label className={styles.ParaName}>
                    تعداد بازدید
                  </label>
                  <span className={styles.paraDec}>
                    تعداد بازدید مورد نظر برای محاسبه CTR
                  </span>
                </div>
                <input
                  type="text"
                  onChange={(e) => {
                    const value = e.target.value;
                    setDataForSend((prev) => ({
                      ...prev,
                      parameter_change: value,
                    }));
                  }}
                />
              </div>
            )}
          </div>
        )}

        <div className="accordion " id="accordionExample">
          <div>
            {myParameters?.map((item, index) => {
              return (
                <React.Fragment key={item.groupId}>
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse${item.groupId}`}
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        {item.groupName}
                      </button>
                    </h2>

                    <div
                      id={`collapse${item.groupId}`}
                      className={`accordion-collapse collapse ${
                        index + 1 === myParameters.length && 'show'
                      }`}
                    >
                      <div
                        className={`accordion-body ${styles.bodyOfAccordion}`}
                      >
                        {item.parameters?.map(
                          (paraItem, paraIndex) => {
                            const valuePara =
                              dataForSend.parameters[
                                paraItem.paraName
                              ];

                            return (
                              <div
                                key={`${item.groupId}${paraItem.paraId}`}
                              >
                                <div className={styles.ParaDiv}>
                                  <div className={styles.toptext}>
                                    <label
                                      className={styles.ParaName}
                                      htmlFor={`${item.groupId}${paraItem.paraId}`}
                                    >
                                      {paraItem.paraName}
                                    </label>
                                    <span className={styles.paraDec}>
                                      {paraItem.paraDescription}
                                    </span>
                                  </div>

                                  {paraItem.paraType !== 'select' ? (
                                    paraItem.paraType === 'color' ? (
                                      <div
                                        className={
                                          styles.divInputPicker
                                        }
                                      >
                                        <div
                                          id="test"
                                          className={styles.Picker}
                                          onMouseLeave={(e) =>
                                            ColorPickerShowHandler(
                                              e,
                                              'leave'
                                            )
                                          }
                                        >
                                          <HexColorPicker
                                            color={valuePara}
                                            onChange={(e) =>
                                              colorHandler(
                                                e,
                                                paraItem.paraName,
                                                'picker'
                                              )
                                            }
                                          />
                                        </div>

                                        <div
                                          className={styles.showcolor}
                                          style={{
                                            backgroundColor:
                                              valuePara ??
                                              'transparent',
                                          }}
                                          onClick={(e) =>
                                            ColorPickerShowHandler(
                                              e,
                                              'enter'
                                            )
                                          }
                                        ></div>
                                        <input
                                          value={valuePara}
                                          placeholder={
                                            valuePara === ''
                                              ? 'اکنون رنگ پیشفرض قالب است'
                                              : ''
                                          }
                                          maxLength={9}
                                          onChange={(e) =>
                                            colorHandler(
                                              e,
                                              paraItem.paraName,
                                              'input'
                                            )
                                          }
                                        />
                                      </div>
                                    ) : paraItem.paraDescription ===
                                      'توکن وب سرویس' ? (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                        name={paraItem.paraName}
                                        value={valuePara}
                                        onChange={inputParaHandler2}
                                      />
                                    ) : paraItem.paraDescription ===
                                      'تایپ لندینگ' ? (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}`}
                                        name={paraItem.paraName}
                                        value={valuePara}
                                        onChange={inputParaHandler3}
                                      />
                                    ) : (
                                      <input
                                        type={paraItem.paraType}
                                        id={`${item.groupId}${paraItem.paraId}`}
                                        name={paraItem.paraName}
                                        value={valuePara}
                                        onChange={inputParaHandler}
                                      />
                                    )
                                  ) : paraItem.paraName !== 'type' ? (
                                    <select
                                      isSearchable
                                      disabled={
                                        disableSubjectAndLabel
                                      }
                                      className={`${styles.SelectPanel} form-select`}
                                      name={paraItem.paraName}
                                      value={
                                        totalSelect[
                                          `${paraItem.paraName}`
                                        ]
                                      }
                                      onChange={selectParaHandler}
                                    >
                                      <option value="">
                                        {paraItem.paraName ===
                                          'type' && loadingType
                                          ? 'صبر کنید...'
                                          : 'انتخاب نشده'}
                                      </option>
                                      {selectOptions[
                                        `${paraItem.paraName}`
                                      ]?.map((itemOp, indexOp) => {
                                        return paraItem.paraName ===
                                          'type' ? (
                                          <option
                                            key={indexOp}
                                            value={itemOp}
                                          >
                                            {itemOp}
                                          </option>
                                        ) : (
                                          <option
                                            key={indexOp}
                                            value={itemOp.id}
                                          >
                                            {itemOp.name}
                                          </option>
                                        );
                                      })}
                                    </select>
                                  ) : (
                                    <Select
                                      showSearch
                                      style={{ width: 200 }}
                                      optionFilterProp="label"
                                      filterOption={(input, option) =>
                                        option.label
                                          .toLowerCase()
                                          .includes(
                                            input.toLowerCase()
                                          )
                                      }
                                      filterSort={(
                                        optionA,
                                        optionB
                                      ) =>
                                        (optionA?.label ?? '')
                                          .toLowerCase()
                                          .localeCompare(
                                            (
                                              optionB?.label ?? ''
                                            ).toLowerCase()
                                          )
                                      }
                                      loading={loadingType}
                                      value={valuePara}
                                      onChange={(value) =>
                                        inputParaHandler({
                                          target: {
                                            name: `${paraItem.paraName}Select`,
                                            value,
                                          },
                                        })
                                      }
                                      allowClear
                                      options={
                                        [
                                          ...new Set(
                                            selectOptions?.[
                                              paraItem.paraName
                                            ] || []
                                          ),
                                        ]?.map((itemOp) => ({
                                          value: itemOp,
                                          label: itemOp,
                                        })) || []
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            );
                          }
                        )}
                      </div>
                    </div>
                  </div>
                </React.Fragment>
              );
            })}

            {advance == 1 && (
              <button
                style={{ margin: 20, padding: 5, width: 220 }}
                className="btn btn-warning ms-4"
                onClick={() => {
                  addParameters();
                }}
              >
                <i className="bi bi-copy"></i>
                <span style={{ padding: 10 }}>
                  کپی از پارامتر اصلی
                </span>
              </button>
            )}
          </div>

          {Object.entries(onlyParameters)?.map(
            ([key, groups], index) => (
              <div key={key} className="mb-6 border p-4 m-4 rounded">
                <h2 className="text-lg font-bold mb-2">{`پارامترها ${
                  index + 2
                }`}</h2>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                  }}
                >
                  {dataForSend?.parameter_group?.change_type ===
                  'time_change' ? (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          مدت زمان
                        </label>
                        <span className={styles.paraDec}>
                          مدت زمان مورد نظر برای محاسبه CTR(دقیقه)
                        </span>
                      </div>
                      <input
                        type="text"
                        onChange={(e) =>
                          handleDurationChange(e, index)
                        }
                      />
                    </div>
                  ) : (
                    <div
                      style={{ width: '45%', minWidth: '220px' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          تعداد بازدید
                        </label>
                        <span className={styles.paraDec}>
                          تعداد بازدید مورد نظر برای محاسبه CTR
                        </span>
                      </div>
                      <input
                        type="text"
                        onChange={(e) => handleViewChange(e, index)}
                      />
                    </div>
                  )}
                  <div
                    style={{ minWidth: '45%' }}
                    className={styles.ParaDiv}
                  >
                    <div className={styles.toptext}>
                      <label className={styles.ParaName}>الویت</label>
                      <span className={styles.paraDec}>
                        الویت از 2 شروع می شود
                      </span>
                    </div>
                    <input
                      onWheel={(e) => e.target.blur()}
                      type="number"
                      min={2}
                      onChange={(e) => handlePriority(e, index)}
                    />
                  </div>
                </div>
                {groups?.map((item, index) => (
                  <React.Fragment key={key}>
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button
                          className="accordion-button"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse${item.groupId}${paramIndex}`}
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          {item.groupName}
                        </button>
                      </h2>

                      <div
                        id={`collapse${item.groupId}${paramIndex}`}
                        className={`accordion-collapse collapse ${
                          index + 1 === myParameters.length && 'show'
                        }`}
                      >
                        <div
                          className={`accordion-body ${styles.bodyOfAccordion}`}
                        >
                          {item.parameters?.map(
                            (paraItem, paraIndex) => {
                              const valuePara =
                                dataForSend[key]?.[paraItem.paraName];

                              return (
                                <div
                                  key={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                >
                                  <div className={styles.ParaDiv}>
                                    <div className={styles.toptext}>
                                      <label
                                        className={styles.ParaName}
                                        htmlFor={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                      >
                                        {paraItem.paraName}
                                      </label>
                                      <span
                                        className={styles.paraDec}
                                      >
                                        {paraItem.paraDescription}
                                      </span>
                                    </div>

                                    {paraItem.paraType !==
                                    'select' ? (
                                      paraItem.paraType ===
                                      'color' ? (
                                        <div
                                          className={
                                            styles.divInputPicker
                                          }
                                        >
                                          <div
                                            id={`test${paramIndex}`}
                                            className={styles.Picker}
                                            onMouseLeave={(e) =>
                                              ColorPickerShowHandler(
                                                e,
                                                'leave'
                                              )
                                            }
                                          >
                                            <HexColorPicker
                                              color={valuePara}
                                              onChange={(e) =>
                                                colorHandler2(
                                                  e,
                                                  paraItem.paraName,
                                                  'picker',
                                                  key
                                                )
                                              }
                                            />
                                          </div>

                                          <div
                                            className={
                                              styles.showcolor
                                            }
                                            style={{
                                              backgroundColor:
                                                valuePara ??
                                                'transparent',
                                            }}
                                            onClick={(e) =>
                                              ColorPickerShowHandler(
                                                e,
                                                'enter'
                                              )
                                            }
                                          ></div>
                                          <input
                                            value={valuePara}
                                            placeholder={
                                              valuePara === ''
                                                ? 'اکنون رنگ پیشفرض قالب است'
                                                : ''
                                            }
                                            maxLength={9}
                                            onChange={(e) =>
                                              colorHandler2(
                                                e,
                                                paraItem.paraName,
                                                'input',
                                                key
                                              )
                                            }
                                          />
                                        </div>
                                      ) : paraItem.paraDescription ===
                                        'توکن وب سرویس' ? (
                                        <input
                                          type={paraItem.paraType}
                                          id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                          name={paraItem.paraName}
                                          value={valuePara}
                                          onChange={(e) =>
                                            inputParaHandler2(e, key)
                                          }
                                        />
                                      ) : paraItem.paraDescription ===
                                        'تایپ لندینگ' ? (
                                        <input
                                          type={paraItem.paraType}
                                          id={`${item.groupId}${paraItem.paraId}`}
                                          name={paraItem.paraName}
                                          value={valuePara}
                                          onChange={(e) => {
                                            inputParaHandler3(e, key);
                                          }}
                                        />
                                      ) : (
                                        <input
                                          type={paraItem.paraType}
                                          id={`${item.groupId}${paraItem.paraId}${paramIndex}`}
                                          name={paraItem.paraName}
                                          value={valuePara}
                                          onChange={(e) =>
                                            inputParaHandlerOthers(
                                              e,
                                              key
                                            )
                                          }
                                        />
                                      )
                                    ) : paraItem.paraName !==
                                      'type' ? (
                                      <select
                                        isSearchable
                                        disabled={
                                          disableSubjectAndLabel
                                        }
                                        className={`${styles.SelectPanel} form-select`}
                                        name={paraItem.paraName}
                                        value={
                                          totalSelect[
                                            `${paraItem.paraName}`
                                          ]
                                        }
                                        onChange={selectParaHandler}
                                      >
                                        <option value="">
                                          {paraItem.paraName ===
                                            'type' && loadingType
                                            ? 'صبر کنید...'
                                            : 'انتخاب نشده'}
                                        </option>
                                        {selectOptions[
                                          `${paraItem.paraName}`
                                        ]?.map((itemOp, indexOp) => {
                                          return paraItem.paraName ===
                                            'type' ? (
                                            <option
                                              key={indexOp}
                                              value={itemOp}
                                            >
                                              {itemOp}
                                            </option>
                                          ) : (
                                            <option
                                              key={indexOp}
                                              value={itemOp.id}
                                            >
                                              {itemOp.name}
                                            </option>
                                          );
                                        })}
                                      </select>
                                    ) : (
                                      <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        optionFilterProp="label"
                                        filterOption={(
                                          input,
                                          option
                                        ) =>
                                          option.label
                                            .toLowerCase()
                                            .includes(
                                              input.toLowerCase()
                                            )
                                        }
                                        filterSort={(
                                          optionA,
                                          optionB
                                        ) =>
                                          (optionA?.label ?? '')
                                            .toLowerCase()
                                            .localeCompare(
                                              (
                                                optionB?.label ?? ''
                                              ).toLowerCase()
                                            )
                                        }
                                        loading={loadingType}
                                        value={valuePara}
                                        onChange={(value) =>
                                          inputParaHandlerOthers({
                                            target: {
                                              name: `${paraItem.paraName}Select`,
                                              value,
                                            },
                                            key,
                                          })
                                        }
                                        allowClear
                                        options={
                                          [
                                            ...new Set(
                                              selectOptions?.[
                                                paraItem.paraName
                                              ] || []
                                            ),
                                          ]?.map((itemOp) => ({
                                            value: itemOp,
                                            label: itemOp,
                                          })) || []
                                        }
                                      />
                                    )}
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))}

                {othersParameters?.variants?.length > 0 &&
                  advance == 1 && (
                    <button
                      style={{ margin: 20, padding: 5, width: 220 }}
                      className="btn btn-danger ms-2"
                      onClick={() => {
                        removeParameter(key);
                      }}
                    >
                      <i className="bi bi-trash"></i>
                      <span style={{ padding: 10 }}>{` حذف پارامتر ${
                        index + 2
                      }`}</span>
                    </button>
                  )}
              </div>
            )
          )}

          {dataForSend?.is_child != 1 && (
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse`}
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  گروه‌های لندینگ
                </button>
              </h2>
              <div
                id={`collapse`}
                className={`accordion-collapse collapse`}
              >
                <div className={`accordion-body `}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{ minWidth: '30%' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          هدف CTR
                        </label>
                        <span className={styles.paraDec}>
                          درصد CTR مورد نظر را وارد کنید(فقط عدد)
                        </span>
                      </div>
                      <input
                        type="text"
                        onChange={(e) => handleCtrTarget(e)}
                      />
                    </div>
                    <div
                      style={{ minWidth: '30%' }}
                      className={styles.ParaDiv}
                    >
                      <div className={styles.toptext}>
                        <label className={styles.ParaName}>
                          CTR براساس:
                        </label>
                        <span className={styles.paraDec}>
                          براساس تعداد بازدید یا مدت زمان
                        </span>
                      </div>
                      <select
                        className={`${styles.SelectPanel} form-select`}
                        value={
                          dataForSend?.landing_group?.change_type
                        }
                        onChange={(e) => {
                          const value = e.target.value;
                          setDataForSend((prev) => ({
                            ...prev,
                            landing_group: {
                              ...prev.landing_group,
                              change_type: value,
                            },
                          }));
                        }}
                      >
                        <option value="">انتخاب کنید</option>
                        <option value="view_change">
                          تعداد بازدید
                        </option>
                        <option value="time_change">مدت زمان</option>
                      </select>
                    </div>
                    {dataForSend?.landing_group?.change_type ===
                    'time_change' ? (
                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label className={styles.ParaName}>
                            مدت زمان
                          </label>
                          <span className={styles.paraDec}>
                            بعد از چه مدت زمانی CTR محاسبه شود؟
                          </span>
                        </div>
                        <input
                          type="text"
                          onChange={(e) =>
                            setDataForSend((prev) => {
                              return {
                                ...prev,
                                view_change: '',
                                time_change: e.target.value,
                              };
                            })
                          }
                        />
                      </div>
                    ) : (
                      <div
                        style={{ minWidth: '30%' }}
                        className={styles.ParaDiv}
                      >
                        <div className={styles.toptext}>
                          <label className={styles.ParaName}>
                            تعداد بازدید
                          </label>
                          <span className={styles.paraDec}>
                            بعد از چه تعداد بازدید CTR لندینگ اصلی
                            محاسبه شود؟
                          </span>
                        </div>
                        <input
                          type="text"
                          onChange={(e) =>
                            setDataForSend((prev) => {
                              return {
                                ...prev,
                                time_change: '',
                                view_change: e.target.value,
                              };
                            })
                          }
                        />
                      </div>
                    )}
                  </div>

                  <h2 style={{ padding: 10, margin: 5 }}>
                    زیرمجموعه ها
                  </h2>

                  {dataForSend.landing_group.landings?.map(
                    (item, index) => (
                      <div
                        key={index}
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                        }}
                      >
                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label
                              className={styles.ParaName}
                              htmlFor={`id-${index}`}
                            >
                              {`زیرمجموعه ${index + 1}`}
                            </label>
                            <span className={styles.paraDec}>
                              لطفا لندینگ فرزند را وارد کنید
                            </span>
                          </div>
                          <CustomSelect
                            options={allLandings}
                            placeholder="لندینگ را انتخاب کنید"
                            onInputChange={handleInputChange}
                            onChange={(selectedOption) => {
                              handleChange(
                                index,
                                'id',
                                selectedOption?.value
                              );
                            }}
                            isClearable
                            isSearchable
                          />
                        </div>

                        <div
                          style={{ minWidth: '30%' }}
                          className={styles.ParaDiv}
                        >
                          <div className={styles.toptext}>
                            <label
                              className={styles.ParaName}
                              htmlFor={`priority-${index}`}
                            >
                              الویت
                            </label>
                            <span className={styles.paraDec}>
                              الویت از 2 شروع می شود
                            </span>
                          </div>
                          <input
                            type="number"
                            min={2}
                            onWheel={(e) => e.target.blur()}
                            onChange={(e) =>
                              handlePriorityLanding(
                                e.target.value,
                                index
                              )
                            }
                          />
                        </div>

                        {dataForSend?.landing_group?.change_type ===
                        'time_change' ? (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                مدت زمان
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه مدت زمانی CTR محاسبه شود؟
                              </span>
                            </div>
                            <input
                              type="text"
                              onChange={(e) =>
                                handleChangeTimeLanding(
                                  e.target.value,
                                  index
                                )
                              }
                            />
                          </div>
                        ) : (
                          <div
                            style={{ minWidth: '30%' }}
                            className={styles.ParaDiv}
                          >
                            <div className={styles.toptext}>
                              <label className={styles.ParaName}>
                                تعداد بازدید
                              </label>
                              <span className={styles.paraDec}>
                                بعد از چه تعداد بازدید CTR محاسبه شود؟
                              </span>
                            </div>
                            <input
                              type="text"
                              onChange={(e) =>
                                handleChangeViewLanding(
                                  e.target.value,
                                  index
                                )
                              }
                            />
                          </div>
                        )}
                        <div
                          style={{
                            height: '1px',
                            backgroundColor: '#ccc',
                            width: '100%',
                            margin: '20px 0',
                          }}
                        />
                      </div>
                    )
                  )}
                </div>
                <button
                  style={{ margin: 20, padding: 5, width: 70 }}
                  className="btn btn-warning ms-2"
                  onClick={handleAddGroup}
                >
                  <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
          )}
        </div>

        <div className={`${styles.btns} mt-5 mb-4`}>
          <button
            className="btn btn-primary ms-2"
            disabled={checkBtnErsal}
            onClick={cheakeAll}
          >
            ایجاد لندینگ
            {checkBtnErsal && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
            )}
          </button>

          <button
            data-bs-toggle="modal"
            style={{ visibility: 'hidden' }}
            id="btnModalAnswer"
            data-bs-target="#askUserTodo"
            onClick={showAwnserForLanding}
          ></button>

          <button
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            بازگشت
          </button>
        </div>

        <ModalYesorNo
          idModal="askUserTodo"
          color="primary"
          byLoading={true}
          stateLoad={isLoadForModalCheck}
          doBtn="ایجاد"
          Click={SendHandler}
        >
          <div className="d-flex align-items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="ms-3"
              width="1.9rem"
              height="1.9rem"
              viewBox="0 0 64 64"
            >
              <path
                fill="#ffce31"
                d="M5.9 62c-3.3 0-4.8-2.4-3.3-5.3L29.3 4.2c1.5-2.9 3.9-2.9 5.4 0l26.7 52.5c1.5 2.9 0 5.3-3.3 5.3z"
              />
              <g fill="#231f20">
                <path d="m27.8 23.6l2.8 18.5c.3 1.8 2.6 1.8 2.9 0l2.7-18.5c.5-7.2-8.9-7.2-8.4 0" />
                <circle cx="32" cy="49.6" r="4.2" />
              </g>
            </svg>
            <span>
              با تایپ و توکن این لندینگ {dataForModalCheck?.count}{' '}
              لندینگ دیگر وجود دارد آیا مایل به ایجاد لندینگ هستید؟
            </span>
          </div>
          <a
            href={`/dashboard/showLandings?type=${dataForSend.parameters.type}&token=${dataForSend.parameters.token}`}
            target="_blank"
          >
            <button className="btn btn-sm btn-dark">مشاهده</button>
          </a>
        </ModalYesorNo>
      </div>
    </>
  ) : (
    <Loading color="#7545fb" />
  );
};

export default InstallLanding;
